export const GET_SECOND_CLASS = "public/get_second_class";
